import CategoryPage from "~/components/faq/CategoryPage"

export default CategoryPage
